// // import { _converse, api, constants } from '@converse/headless';
// // import 'plugins/chatview/heading.js';
// // import 'plugins/chatview/bottom-panel.js';
// // import BaseChatView from 'shared/chat/baseview.js';
// // import { __ } from 'i18n';
// // import DragResizable from 'plugins/dragresize/mixin.js';
// // import tplChat from './templates/chat.js';

// // const { ACTIVE,INACTIVE } = constants;

// // /**
// //  * The view of an open/ongoing chat conversation.
// //  */
// // export default class ChatView extends DragResizable(BaseChatView) {
// //     length = 200;

// //     async initialize() {
// //         const { chatboxviews, chatboxes } = _converse.state;
// //         chatboxviews.add(this.jid, this);
// //         this.model = chatboxes.get(this.jid);
// //         this.listenTo(this.model, 'change:requesting', () => this.requestUpdate());
// //         this.listenTo(this.model, 'change:hidden', () => !this.model.get('hidden') && this.afterShown());
// //         this.listenTo(this.model, 'change:show_help_messages', () => this.requestUpdate());
// //         this.listenTo(this.model, 'contact:add', () => this.requestUpdate());
// //         this.listenTo(this.model, 'contact:change', () => this.requestUpdate());
// //         this.listenTo(this.model, 'contact:destroy', () => this.requestUpdate());

// //         document.addEventListener('visibilitychange', () => this.onWindowStateChanged());

// //         await this.model.messages.fetched;
// //         !this.model.get('hidden') && this.afterShown();
// //         /**
// //          * Triggered once the {@link ChatView} has been initialized
// //          * @event _converse#chatBoxViewInitialized
// //          * @type {ChatView}
// //          * @example _converse.api.listen.on('chatBoxViewInitialized', view => { ... });
// //          */
// //         api.trigger('chatBoxViewInitialized', this);
// //     }

// //     onWindowStateChanged() {
// //         const isHidden = document.hidden;

// //         // 1. Меняем флаг ТИХО. Пакет не шлется, UI не моргает.
// //         // Но теперь модель ЗНАЕТ, что она hidden.
// //         this.model.set('hidden', isHidden, { silent: true });

// //         if (isHidden) {
// //             // 2. Проверяем текущий статус
// //             if (this.model.get('chat_state') !== constants.INACTIVE) {
// //                 // 3. Шлем ИНАКТИВ. Этот метод внутри себя сделает ОБЫЧНЫЙ set('chat_state'),
// //                 // который триггернет отправку пакета в WebSocket,
// //                 // но Lit-компонент обычно не перерисовывается от смены chat_state (если нет подписки в render).
// //                 this.model.setChatState(constants.INACTIVE);
// //             }
// //         } else {
// //             // Когда вернулись — проверяем, нужно ли «просыпаться»
// //             if (this.model.get('chat_state') !== constants.ACTIVE) {
// //                 this.afterShown();
// //             }
// //         }
// //     }

// //     render() {
// //         return tplChat(this);
// //     }

// //     getHelpMessages() {
// //         return [
// //             `<strong>/clear</strong>: ${__('Remove messages')}`,
// //             `<strong>/close</strong>: ${__('Close this chat')}`,
// //             `<strong>/me</strong>: ${__('Write in the third person')}`,
// //             `<strong>/help</strong>: ${__('Show this menu')}`,
// //         ];
// //     }

// //     afterShown() {
// //         this.model.setChatState(ACTIVE);
// //         this.model.clearUnreadMsgCounter();
// //         this.maybeFocus();
// //     }
// // }

// // api.elements.define('converse-chat', ChatView);
// import { _converse, api, constants } from '@converse/headless';
// import 'plugins/chatview/heading.js';
// import 'plugins/chatview/bottom-panel.js';
// import BaseChatView from 'shared/chat/baseview.js';
// import { __ } from 'i18n';
// import DragResizable from 'plugins/dragresize/mixin.js';
// import tplChat from './templates/chat.js';

// const { ACTIVE, INACTIVE } = constants;

// /**
//  * The view of an open/ongoing chat conversation.
//  */
// export default class ChatView extends DragResizable(BaseChatView) {
//     length = 200;

//     async initialize() {
//         const { chatboxviews, chatboxes } = _converse.state;
//         chatboxviews.add(this.jid, this);
//         this.model = chatboxes.get(this.jid);

//         this.listenTo(this.model, 'change:requesting', () => this.requestUpdate());
//         this.listenTo(this.model, 'change:show_help_messages', () => this.requestUpdate());
//         this.listenTo(this.model, 'contact:add', () => this.requestUpdate());
//         this.listenTo(this.model, 'contact:change', () => this.requestUpdate());
//         this.listenTo(this.model, 'contact:destroy', () => this.requestUpdate());

//         this._onVisibilityChange = () => this.onWindowStateChanged();
//         document.addEventListener('visibilitychange', this._onVisibilityChange);

//         await this.model.messages.fetched;

//         // Первичная проверка видимости при загрузке
//         if (!this.model.get('hidden') && !document.hidden) {
//             this.afterShown();
//         }

//         /**
//          * Triggered once the {@link ChatView} has been initialized
//          * @event _converse#chatBoxViewInitialized
//          */
//         api.trigger('chatBoxViewInitialized', this);
//     }

//     /**
//      * Handles the drop event to send files dragged-and-dropped into the chat.
//      * @param {DragEvent} ev
//      */
//     // onDrop(ev) {
//     //     if (ev.dataTransfer.files.length == 0) {
//     //         return;
//     //     }
//     //     console.log('files transfer chat');
//     //     ev.preventDefault();
//     //     this.model.sendFiles(ev.dataTransfer.files);
//     // }

//     onDrop(ev) {
//         ev.preventDefault();
//         const files = ev.dataTransfer.files;
//         if (files.length === 0) return;

//         // Сохраняем файлы и открываем попап
//         this.pendingFiles = files;
//         this.model.set('show_drop_confirmation', true);
//     }

//     confirmFileSend() {
//         if (this.pendingFiles) {
//             this.model.sendFiles(this.pendingFiles);
//         }
//         this.closeDropConfirmation();
//     }

//     closeDropConfirmation() {
//         this.pendingFiles = null;
//         this.model.set('show_drop_confirmation', false);
//     }

//     /**
//      * Обработчик сворачивания/разворачивания вкладки браузера.
//      * Оптимизирован для исключения "моргания" интерфейса.
//      */
//     onWindowStateChanged() {
//         const isHidden = document.hidden;

//         // 1. Меняем флаг hidden в модели ТИХО ({silent: true}).

//         this.model.set('hidden', isHidden, { silent: true });

//         if (isHidden) {
//             // 2. Если вкладка скрыта — шлем INACTIVE, только если он уже не установлен.
//             if (this.model.get('chat_state') !== INACTIVE) {
//                 console.log(`[ChatState] Вкладка скрыта, отправка INACTIVE для ${this.jid}`);
//                 this.model.setChatState(INACTIVE);
//             }
//         } else {
//             // 3. Если вернулись во вкладку

//             if (this.model.get('chat_state') !== ACTIVE) {
//                 console.log(`[ChatState] Вкладка активна, активация чата ${this.jid}`);
//                 this.afterShown();
//             } else {
//                 // Если и так активен, просто фокусируем поле ввода без перерисовки
//                 this.maybeFocus();
//             }
//         }
//     }

//     /**
//      * Очистка при удалении компонента
//      */
//     disconnectedCallback() {
//         super.disconnectedCallback();
//         document.removeEventListener('visibilitychange', this._onVisibilityChange);
//     }

//     render() {
//         return tplChat(this);
//     }

//     getHelpMessages() {
//         return [
//             `<strong>/clear</strong>: ${__('Remove messages')}`,
//             `<strong>/close</strong>: ${__('Close this chat')}`,
//             `<strong>/me</strong>: ${__('Write in the third person')}`,
//             `<strong>/help</strong>: ${__('Show this menu')}`,
//         ];
//     }

//     afterShown() {
//         // Убеждаемся, что принудительно ставим ACTIVE и чистим счетчики
//         this.model.setChatState(ACTIVE);
//         this.model.clearUnreadMsgCounter();
//         this.maybeFocus();
//     }
// }

// api.elements.define('converse-chat', ChatView);

import { _converse, api, constants } from '@converse/headless';
import 'plugins/chatview/heading.js';
import 'plugins/chatview/bottom-panel.js';
import BaseChatView from 'shared/chat/baseview.js';
import { __ } from 'i18n';
import DragResizable from 'plugins/dragresize/mixin.js';
import tplChat from './templates/chat.js';

const { ACTIVE, INACTIVE } = constants;

/**
 * The view of an open/ongoing chat conversation.
 */
export default class ChatView extends DragResizable(BaseChatView) {
    length = 200;

    async initialize() {
        const { chatboxviews, chatboxes } = _converse.state;
        chatboxviews.add(this.jid, this);
        this.model = chatboxes.get(this.jid);

        // КРИТИЧЕСКИЙ СБРОС:
        // Сбрасываем флаг подтверждения дропа при каждой инициализации вида.
        // Это предотвращает появление "фантомного" модального окна после обновления страницы.
        this.model.set('show_drop_confirmation', false);

        this.listenTo(this.model, 'change:requesting', () => this.requestUpdate());
        this.listenTo(this.model, 'change:show_help_messages', () => this.requestUpdate());
        this.listenTo(this.model, 'change:show_drop_confirmation', () => this.requestUpdate());
        this.listenTo(this.model.ui, 'change', () => this.requestUpdate());
        this.listenTo(this.model, 'contact:add', () => this.requestUpdate());
        this.listenTo(this.model, 'contact:change', () => this.requestUpdate());
        this.listenTo(this.model, 'contact:destroy', () => this.requestUpdate());
        this.listenTo(this.model, 'files-dropped', (files) => {
            this.pendingFiles = files;
            this.model.set('show_drop_confirmation', true);
        });

        this._onVisibilityChange = () => this.onWindowStateChanged();
        document.addEventListener('visibilitychange', this._onVisibilityChange);

        // Messages that arrive while the window is visible but NOT focused are
        // counted as unread with their read marker held back (see isTabAway in
        // headless/shared/model-with-messages.js). `visibilitychange` doesn't
        // fire for a focus-only change, so flush them when focus comes back.
        this._onWindowFocus = () => {
            if (!document.hidden && !this.model.get('hidden')) {
                this.model.clearUnreadMsgCounter();
            }
        };
        window.addEventListener('focus', this._onWindowFocus);

        await this.model.messages.fetched;

        // Первичная проверка видимости при загрузке
        if (!this.model.get('hidden') && !document.hidden) {
            this.afterShown();
        }

        /**
         * Triggered once the {@link ChatView} has been initialized
         * @event _converse#chatBoxViewInitialized
         */
        api.trigger('chatBoxViewInitialized', this);
    }

    /**
     * Центральный обработчик Drop.
     * Использует stopPropagation, чтобы событие не уходило в textarea.
     */
    onDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        const files = ev.dataTransfer.files;
        if (files && files.length > 0) {
            this.pendingFiles = files;
            this.model.set('show_drop_confirmation', true);
        }
    }

    /**
     * Вызывается при нажатии "Надіслати" в модальном окне.
     */
    confirmFileSend() {
        if (this.pendingFiles) {
            this.model.sendFiles(this.pendingFiles);
        }
        this.closeDropConfirmation();
    }

    /**
     * Закрывает модальное окно и очищает очередь файлов.
     */
    closeDropConfirmation() {
        this.pendingFiles = null;
        this.model.set('show_drop_confirmation', false);
    }

    /**
     * Обработчик сворачивания/разворачивания вкладки браузера.
     */
    onWindowStateChanged() {
        const isHidden = document.hidden;
        this.model.set('hidden', isHidden, { silent: true });

        if (isHidden) {
            if (this.model.get('chat_state') !== INACTIVE) {
                this.model.setChatState(INACTIVE);
            }
        } else {
            if (this.model.get('chat_state') !== ACTIVE) {
                this.afterShown();
            } else {
                this.maybeFocus();
            }
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('visibilitychange', this._onVisibilityChange);
        window.removeEventListener('focus', this._onWindowFocus);
    }

    render() {
        return tplChat(this);
    }

    getHelpMessages() {
        return [
            `<strong>/clear</strong>: ${__('Remove messages')}`,
            `<strong>/close</strong>: ${__('Close this chat')}`,
            `<strong>/me</strong>: ${__('Write in the third person')}`,
            `<strong>/help</strong>: ${__('Show this menu')}`,
        ];
    }

    afterShown() {
        this.model.setChatState(ACTIVE);
        this.model.clearUnreadMsgCounter();
        this.maybeFocus();
    }
}

api.elements.define('converse-chat', ChatView);
